"use strict";

exports.__esModule = true;
exports.ElementCanvasSizeControlGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _Core = require("../../../Core");
var _styles = require("../../common/styles");
var _class, _ElementCanvasSizeControlGroup;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Controls for changing the size of the selected element
 */
var ElementCanvasSizeControlGroup = exports.ElementCanvasSizeControlGroup = (0, _Core.withTranslator)(_class = (_ElementCanvasSizeControlGroup = /*#__PURE__*/function (_Component) {
  function ElementCanvasSizeControlGroup() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementCanvasSizeControlGroup, _Component);
  var _proto = ElementCanvasSizeControlGroup.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      element = _this$props.element,
      path = _this$props.path,
      elementEditor = _this$props.elementEditor,
      translator = _this$props.translator;
    var _element$props = element.props,
      width = _element$props.width,
      height = _element$props.height;
    var translate = translator.translate;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginBottom: "5px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_styles.LayoutElementTitle, null, translate("ElementCanvasSizeControlGroup.layout.label", "Layout")), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      minimal: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "ElementCanvasSizeControlGroup.presetSizeButton.phone",
      active: width === 360 && height === 640 || height === 360 && width === 640,
      onClick: function onClick() {
        return elementEditor.setProps(path, {
          width: 360,
          height: 640
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ElementCanvasSizeControlGroup.presetSize.phone",
      defaultMessage: "Phone"
    })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "ElementCanvasSizeControlGroup.presetSizeButton.tablet",
      active: width === 718 && height === 974 || height === 718 && width === 974,
      onClick: function onClick() {
        return elementEditor.setProps(path, {
          width: 718,
          height: 974
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ElementCanvasSizeControlGroup.presetSize.tablet",
      defaultMessage: "Tablet"
    })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "ElementCanvasSizeControlGroup.presetSizeButton.hdtv",
      active: width === 1920 && height === 1080 || height === 1920 && width === 1080,
      onClick: function onClick() {
        return elementEditor.setProps(path, {
          width: 1920,
          height: 1080
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ElementCanvasSizeControlGroup.presetSize.hdtv",
      defaultMessage: "HDTV"
    })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "ElementCanvasSizeControlGroup.presetSizeButton.4ktv",
      active: width === 3840 && height === 2160 || height === 3840 && width === 2160,
      onClick: function onClick() {
        return elementEditor.setProps(path, {
          width: 3840,
          height: 2160
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ElementCanvasSizeControlGroup.presetSize.4ktv",
      defaultMessage: "4K TV"
    }))));
  };
  return ElementCanvasSizeControlGroup;
}(_react.Component), _ElementCanvasSizeControlGroup.defaultProps = {
  translator: undefined
}, _ElementCanvasSizeControlGroup)) || _class;